module.exports = __webpack_public_path__ + "media/company.047ea86f.mp4";